"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleMobile = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const localeUtils_1 = require("../../utils/localeUtils");
const LocaleIcon_1 = require("./LocaleIcon");
const LocaleMobileTray_1 = require("./LocaleMobileTray");
const Styled = styled_components_1.default.div `
	height: ${(p) => p.theme.navHeight}px;
	cursor: pointer;
	width: ${(p) => p.theme.navHeight * 2}px;
	position: absolute;
	right: 0;
	${(p) => p.theme.breakpoints.down("xs")} {
		width: ${(p) => p.theme.navHeight}px;
	}

	&.no-signin {
		width: 100%;
		${(p) => p.theme.breakpoints.down("xs")} {
			width: 100%;
		}
	}
`;
const LocaleMobile = ({ hide, locale, localeOptions, hideSignIn }) => {
    const { messages } = (0, shared_1.useMessages)();
    const { menuOpen, setMenuOpen } = (0, shared_1.useLocaleMobileTray)();
    const toggleMenu = (0, shared_1.useToggleMenu)(menuOpen, setMenuOpen, LocaleMobileTray_1.localeMobileMenuId);
    const onKeyUp = (0, shared_1.useHandleKeyUp)(toggleMenu, toggleMenu);
    if (hide)
        return null;
    const { currentLocaleName } = (0, localeUtils_1.getSortedLocaleOptions)(localeOptions, locale, messages.locale);
    return (react_1.default.createElement(Styled, { role: "menu", className: hideSignIn ? "no-signin" : "", tabIndex: 0, onClick: toggleMenu, onKeyUp: onKeyUp },
        react_1.default.createElement(LocaleIcon_1.LocaleIcon, { currentLocale: currentLocaleName })));
};
exports.LocaleMobile = LocaleMobile;
//# sourceMappingURL=LocaleMobile.js.map